import React, { useState, useEffect } from "react";
import { defaultStyles } from "../../../constants/style-constants/utils";
// import Modal from "./Modal";
import { Button } from "../../../components/styled-components/button";
import fileIcon from "../../../assets/images/DeathModuleNew/Icons.png";

import * as Style from "../styles/ModalStyle";
import { Icon, Modal, Select, Row, Col, Radio, Input } from "antd";
import Currency from "../../../components/form/Currency";
import { InputGroup } from "../../../components/inputGroup/InputGroup";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import PhoneNum from "../../../components/form/components/Countrycode";
import TextArea from "antd/lib/input/TextArea";
import WebAddress from "../../../components/form/WebAddress";
import swal from "sweetalert";
import { DatePicker } from "antd";
import DEATH_API from "../../../apis/death.api";
const { Option } = Select;

function UpdateFuneralModal({
  show,
  close,
  fields,
  submitData,
  modalTitle,
  handlechange,
  handleDocumentChange,
  handleDatePickerChange,
  handleRadioChange,
  handlePhoneChange,
  handleSelectChange,
  obj,
  role,
}) {
  const { styles } = defaultStyles;
  const [formData, setFormData] = useState({});
  const [textField, setTextField] = useState(false);
  const [cermation, setCermation] = useState(false);
  const [otherPreference, setOtherPreference] = useState(false);

  const [burial, setburial] = useState(false);
  const [scattering, setScattering] = useState(false);
  const [showFields, setShowFields] = useState({});
  const [radioFields, setRadioFields] = useState(null);

  const [loading, setLoading] = useState(false);
  const [templateDesign, setTemplateDesign] = useState("");
  console.log(fields, "fields newww");
  const [selectListCustomtext, setselectListCustomtext] = useState({});
  const handleSubmit = () => {
    submitData();
    close();
  };
  useEffect(() => {
    if(obj && obj["burial"] ){
      setburial(true);
      setCermation(false);

    }
    else if(obj && obj["cremation"]){
      setburial(false);
      setCermation(true);

    }

  }, []);
  console.log("show....", show);

  for (let i = 0; i < fields.length; i++) {
    console.log("fieldssssss", fields[i]);
  }
  return (
    <Modal footer={null} closable={false} visible={show} centered>
      {console.log("show in modal", show)}
      <Style.HeaderConatiner>
        <Style.ModalTitle> {modalTitle}</Style.ModalTitle>
        {/* <Icon type="close" onClick={close}></Icon> */}
      </Style.HeaderConatiner>

      <div
        style={{
          marginTop: "1rem",
          maxHeight: "25rem",
          overflow: "scroll",
          padding: "1rem",
        }}
      >
        {fields.map((item, idx) => {
          const {
            title,
            type,
            options = [],
            index = null,
            isRequired = false,
            def = null,
            isDisabled = false,
          } = item;
          switch (type) {
            case "email":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <Style.Input
                    defaultValue={def}
                    value={obj ? obj[index] : ""}
                    name={item.title}
                    onChange={(e) => {
                      e.preventDefault();
                      obj[index] = e.target.value;
                      handlechange(e);
                    }}
                    size="large"
                    placeholder={`Enter ${title}`}
                    // name="client_primaryContactNumber"
                  ></Style.Input>
                </div>
              );
            case "input":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                  {/* <Form.Item label={title} validateStatus={"error"}> */}
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  {console.log("role in update", role)}
                  {title === "2FA" ? (
                    <Style.Input
                      // defaultValue={def}
                      disabled={role==="protrustee" ? (item.title ==="Preferred Funeral Home/Mortuary" || item.title ==="Address" || item.title ==="Phone Number" ) ? false : true :false}


                       value={obj ? obj[index] : ""}
                      name={index}
                      // name={item.title}
                      onChange={(e) => {
                        e.preventDefault();
                        obj[index] = e.target.value;
                        handlechange(e);
                      }}
                      size="large"
                      placeholder={`Google Auth, YubiKey, SMS/Text, etc.`}
                      // name="client_primaryContactNumber"
                    ></Style.Input>
                  ) : (
                    <Style.Input
                      // defaultValue={def}
                      disabled={role==="protrustee" ? (item.title ==="Preferred Funeral Home/Mortuary" || item.title ==="Address" || item.title ==="Phone Number" ) ? false : true :false}
                      value={obj ? obj[index] : ""}
                      name={index}
                      // name={item.title}
                      onChange={(e) => {
                        e.preventDefault();
                        obj[index] = e.target.value;
                        handlechange(e);
                      }}
                      size="large"
                      placeholder={`Enter ${title}`}
                      // name="client_primaryContactNumber"
                    ></Style.Input>
                  )}
                </div>
              );
            case "emails":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                  {/* <Form.Item label={title} validateStatus={"error"}> */}
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <Style.Input
                    // className="custom-input"
                    defaultValue={def}
                    disabled={isDisabled}
                    value={obj ? obj[index] : ""}
                    name={index}
                    onChange={(e) => {
                      e.preventDefault();
                      obj[index] = e.target.value;
                      handlechange(e);
                    }}
                    
                    size="large"
                    placeholder={`Enter ${title}`}
                    // name="client_primaryContactNumber"
                  ></Style.Input>
                </div>
              );
            case "Title":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                  <div
                    style={{
                      fontFamily: "Poppins",
                      fontSize: "14px",
                      fontWeight: "600",
                      color: "#4d5e80",
                    }}
                  >
                    {item.title}
                  </div>
                </div>
              );
            case "phoneNumber":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                  {/* <Form.Item label={title} validateStatus={"error"}> */}
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <PhoneNum
                    defaultValue={def}
                    disabled={isDisabled}
                    value={obj ? obj[index] : ""}
                    name={index}
                    onChange={(e) => {
                      // handlechange(e);
                      handlePhoneChange(index, e.target.value);
                    }}
                    size="large"
                    placeholder={`Enter ${title}`}
                    // name="client_primaryContactNumber"
                  ></PhoneNum>
                </div>
              );
            case "phoneNumberA":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                  {/* <Form.Item label={title} validateStatus={"error"}> */}
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <PhoneNum
                    defaultValue={def}
                    disabled={isDisabled}
                    value={obj ? obj[index] : ""}
                    name={index}
                    onChange={(e) => {
                      handlePhoneChange(index, e.target.value);

                      // handlechange(e);
                    }}
                    size="large"
                    placeholder={`Enter ${title}`}
                    // name="client_primaryContactNumber"
                  ></PhoneNum>
                </div>
              );
            case "currency":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <Currency
                    id={index}
                    value={obj ? obj[index] : ""}
                    placeholder={`Enter ${title}`}
                    name={index}
                    onChange={(event) => {
                      event.preventDefault();

                      handlechange(event);
                    }}
                  ></Currency>
                </div>
              );
           
            case "select":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                  <Select
                    showSearch
                    placeholder={item.title}
                    disabled={role ==="protrustee" ? true : false}
                    // value={obj ? obj["burial"] && "Burial" || obj["cremation"] && "Cremation" : ""}
                    value={obj ? (obj["cremation1"] ? obj["cremation1"]  : (obj["burial"] ? "Burial" : obj["cremation"] ? "Cremation" : "")) : ""}
                    name={index}
                    onChange={(value, id) => {
                      if (value) {
                        handleSelectChange(index, value);
                        obj["cremation1"]=value;
                        if (value === "Burial") {
                          setburial(true);
                          setCermation(false);
                        }
                        if (value === "Cremation") {
                          console.log("value", value);
                          setCermation(true);
                          setburial(false);
                        }
                        else {
                          setFormData({
                            [index]: value,
                          });
                        }


                      } else {
                        setFormData({
                          ["TemplateID"]: id.key,
                        });
                      }
                    }}
                  >
                   
                    {index !== "Templates" &&
                      index !== "TextTemplates" &&
                      // console.log("options", options)
                      options &&
                      options.map((item, index) => {
                        return (
                          <Option key={index} value={item}>
                            {item}
                          </Option>
                        );
                      })}
                  </Select>

                  {burial && (
                    <div style={{ marginTop: "8px" }}>
                      <Radio.Group
                      value={obj ? obj["burial"] : ""}
                        onChange={(e) => {
                          handleRadioChange("burial", e.target.value);
                        }}
                      >
                        {[
                          "Ground Burial",
                          "Mausoleum",
                          "Above-ground Crypt",
                        ].map((value, vindex) => (
                          <Radio.Button key={vindex} value={value}>
                            {value}
                          </Radio.Button>
                        ))}
                      </Radio.Group>
                    </div>
                  )}
                  {console.log("object update",cermation)}
                  {cermation && (
                    <div style={{ marginTop: "8px" }}>
                      <Radio.Group
                      value={obj ? obj["cremation"] : ""}
                        onChange={(e) => {
                          console.log("value radio", e.target.value);
                          handleRadioChange("cremation", e.target.value);
                          if (e.target.value === "Scattering") {
                            setScattering(true);
                          }
                          else{
                            setScattering(false);
                          }
                        }}
                      >
                        {[
                          "Ground Cremation",
                          "Mausoleum",
                          "Cremation Garden",
                          "Scattering",
                        ].map((value, vindex) => (
                          <Radio.Button key={vindex} value={value}>
                            {value}
                          </Radio.Button>
                        ))}
                      </Radio.Group>
                    </div>
                  )}
                  {scattering || obj && obj["scatteringLocation"] && (
                    <div style={{ marginTop: "8px" }}>
                      <Style.Input
                        disabled={isDisabled}
                        value={obj ? obj["scatteringLocation"] : ""}
                        name="scatteringLocation"
                        // name={item.title}
                        onChange={(e) => {
                          e.preventDefault();
                          obj["scatteringLocation"] = e.target.value;
                          handlechange(e);
                        }}
                        size="large"
                        placeholder={`Enter ${title}`}
                      ></Style.Input>
                    </div>
                  )}
                  {selectListCustomtext && selectListCustomtext[index] && (
                    <div className="custom-field-align">
                      <Input
                        id={`section${index}`}
                        name={title}
                        type="text"
                        placeholder={`Enter ${title}`}
                        size={"large"}
                        onChange={(e) => {
                          // console.log("value....", e.target.value)
                        }}
                      />
                      <Button
                        className="button-set"
                        onClick={() => {
                          const value = document.getElementById(
                            `section${index}`
                          ).value;
                          setFormData({
                            [index]: value,
                          });
                          setselectListCustomtext((prevFormData) => ({
                            ...prevFormData,
                            [index]: false,
                          }));
                          // this.setState({
                          //   selectListCustomtext: {
                          //     ...this.state.selectListCustomtext,
                          //     [index]: false,
                          //   },
                          // });
                        }}
                      >
                        OK
                      </Button>{" "}
                    </div>
                  )}

                  {}
                </div>
              );

            case "date":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <DatePicker
                    size="large"
                    // style={{ width: "100%" }}
                    disabled={role ==="protrustee" ? true : false}
                    format={"MM/DD/YYYY"}
                    // value={formData && formData[index] &&  moment(formData[index]) || (obj && obj[index] && moment(obj[index])) || null}

                    name={item.title}
                    onChange={(date, dateString) => {
                      handleDatePickerChange(item.title, dateString);
                      setFormData({
                        [index]: dateString,
                      });
                    }}
                  />
                </div>
              );

            case "textarea":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <TextArea
                  disabled={role ==="protrustee" ? true : false}
                    id={index}
                    value={obj ? obj[index] : ""}
                    placeholder={`Enter ${title}`}
                    name={index}
                    onChange={handlechange}
                    
                  />
                </div>
              );


            case "radio":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                  {console.log("obj[index] tilte", obj[index])}
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <Radio.Group
                  disabled={role ==="protrustee" ? true : false}
                  value={obj ? obj[index] : ""}
                    onChange={(e) => {
                      handleRadioChange(index, e.target.value);
                      obj[index]=e.target.value
                  
                       if(e.target.value==="Stay On" ){
                        console.log("obj[index]111",index)
                        if(obj[`${index}ReturnTo`]){
                        delete obj[`${index}ReturnTo`];
                        }
                        setShowFields({
                          ...showFields,
                          [index]: false,
                        });
                      }
                      if(e.target.value==="Return To" ){
                        console.log("obj[index]111",index)
                        setShowFields({
                          ...showFields,
                          [index]: true,
                        });
                      }
                     
                      else{
                        setShowFields({
                          ...showFields,
                          [index]: false,
                        });
                      }
                    }}
                  >
                    {options.map((value, vindex) => (
                      <Radio.Button key={vindex} value={value}>
                        {value}
                      </Radio.Button>
                    ))}
                  </Radio.Group>

                  {(showFields[index] || obj && obj[`${index}ReturnTo`]) && (
                    <div style={{ marginTop: "8px" }}>
                      <Style.Input
                        disabled={isDisabled}
                        value={obj ? obj[`${index}ReturnTo`] : ""}
                        name={`${index}ReturnTo`}
                        // name={item.title}
                        onChange={(e) => {
                          e.preventDefault();
                          obj[`${index}ReturnTo`] = e.target.value;
                          handlechange(e);
                        }}
                        size="large"
                        placeholder={`Enter ${title}`}
                      ></Style.Input>
                    </div>
                  )}

                </div>
              );

              case "radio1":
                return (
                  <div key={idx} style={{ marginTop: "8px" }}>
                    <Radio.Group
                    disabled={role ==="protrustee" ? true : false}
                    value={obj ? obj[index] : ""}
                      onChange={(e) => {
                        handleRadioChange(index, e.target.value);
  
                        console.log("obj[index]",e.target.value)
                       
                        if(e.target.value==="Other"){
                          setOtherPreference(true);
                        }
                        else{
                         
                          setOtherPreference(false);
                        }
                      }}
                    >
                      {options.map((value, vindex) => (
                        <Radio.Button key={vindex} value={value}>
                          {value}
                        </Radio.Button>
                      ))}
                    </Radio.Group>
                    {(otherPreference || obj && obj["otherPreference"]) && (
                      <div style={{ marginTop: "8px" }}>
                        <Style.Input
                          disabled={isDisabled}
                          value={obj ? obj["otherPreference"] : ""}
                          name="otherPreference"
                          // name={item.title}
                          onChange={(e) => {
                            e.preventDefault();
                            obj["otherPreference"] = e.target.value;
                            handlechange(e);
                          }}
                          size="large"
                          placeholder={`Enter ${title}`}
                        ></Style.Input>
                      </div>
                    )}

  
                  </div>
                );
            
          }
        })}
      </div>

      <Style.WrapperButtons>
        <Style.CancelButton onClick={close}>Cancel</Style.CancelButton>
        <Style.SaveButton onClick={handleSubmit}>Save</Style.SaveButton>
      </Style.WrapperButtons>
    </Modal>
  );
}

export default UpdateFuneralModal;
